import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { bomFabric, fabricOptions } from "@/lib/cutTickets";

const label = (m) => `${m.name} · ${m.supplier || "-"}${m.season ? ` (${m.season})` : ""}`;

// Tessuto esatto da usare per ogni colore, accanto al tipo di tessuto dei grafici
export const FabricPerColor = ({ type: raw, types = [], bom, lines, mats, phases = {}, onChange, gi }) => {
  const type = types.find((t) => t.toLowerCase() === (raw || "").trim().toLowerCase())
    || mats.find((m) => m.type === "tessuto" && m.name.toLowerCase() === (raw || "").trim().toLowerCase())?.fabric_type || (raw || "").trim();
  const colored = lines.map((l, i) => ({ l, i })).filter(({ l }) => l.color.trim());
  if (!type || !colored.length) return null;
  return (
    <div className="mt-1.5 flex flex-wrap gap-x-4 gap-y-1.5 normal-case tracking-normal" data-testid={`ticket-fabric-group-${gi}-colors`}>
      {colored.map(({ l, i }) => {
        const { all, same } = fabricOptions(mats, type, l.color);
        const opts = [...same, ...all.filter((m) => !same.includes(m))];
        const value = l.fabrics?.[type] || bomFabric(bom, l.color, type, mats) || (same.length === 1 ? same[0].id : "");
        const ph = phases[l.color.toLowerCase()];
        const locked = ph && ph !== "programmato";
        const cur = mats.find((m) => m.id === value);
        const set = (v) => onChange(lines.map((x, j) => (j === i ? { ...x, fabrics: { ...(x.fabrics || {}), [type]: v } } : x)));
        return (
          <label key={i} className="flex items-center gap-1.5 text-xs font-normal">
            <span className={!value && same.length > 1 ? "text-amber-400" : "text-muted-foreground"}>{l.color}:</span>
            {locked ? <span className="text-foreground">{cur ? label(cur) : "-"}</span>
              : opts.length ? (
                <Select value={value || undefined} onValueChange={set}>
                  <SelectTrigger className="h-7 min-w-[220px] bg-background text-xs text-foreground" data-testid={`ticket-fabric-${gi}-color-${i}`}>
                    <SelectValue placeholder={same.length ? "Scegli il fornitore" : `Nessun ${type} ${l.color}: scegli`} />
                  </SelectTrigger>
                  <SelectContent>{opts.map((m) => <SelectItem key={m.id} value={m.id}>{label(m)} · {m.color || "-"}</SelectItem>)}</SelectContent>
                </Select>
              ) : <span className="text-rose-400">nessun tessuto di questo tipo in magazzino</span>}
          </label>
        );
      })}
    </div>
  );
};
